export const tagModule = {
  state: {
    selectedTags: [],
    selectedRootPages: [],
    preselectPage: null,
  },

  actions: {
    updateHash({ getters, state }) {
      if (getters.selectedTags.length || getters.preselectPage) {
        let newHash = '#';

        if (getters.preselectPage) {
          newHash += `/${getters.preselectPage}`;
        }

        if (getters.selectedTags.length) {
          const tags = getters.selectedTags.sort((a, b) => a - b);
          newHash += `/q=${tags.join(',')}`;
        }

        history.pushState(null, null, newHash);
      } else {
        history.pushState(null, null, '#/');
      }
    },
    selectTagsFromHash(context) {
      const pageUidMatch = location.hash.match(/\/(\d+)/);
      const tagsMatch = location.hash.match(/\/q=([\d,]+)/);

      if (pageUidMatch) {
        const pageUid = parseInt(pageUidMatch[1]);
        context.commit('updatePreselectPage', pageUid);
      } else if (tagsMatch) {
        const tags = tagsMatch[1]
          .split(',')
          .map(uid => parseInt(uid));
        context.commit('updateSelectedTags', tags);
      }

      context.dispatch('updateHash');
    },
    toggleRootPage(context, payload) {
      if (context.state.selectedRootPages.includes(payload)) {
        context.commit('deselectRootPage', payload);
      } else {
        context.commit('selectRootPage', payload);
      }
    },
  },

  mutations: {
    // Tags
    updateSelectedTags(state, payload) {
      state.selectedTags = payload;
    },
    selectTag(state, payload) {
      if (!state.selectedTags.includes(payload)) {
        state.selectedTags.push(payload);
      }
    },
    deselectTag(state, payload) {
      state.selectedTags = state.selectedTags
        .filter(cat => cat !== payload);
    },

    // Root Pages
    updateSelectedRootPages(state, payload) {
      state.selectedRootPages = payload;
    },
    selectRootPage(state, payload) {
      if (!state.selectedRootPages.includes(payload)) {
        state.selectedRootPages.push(payload);
      }
    },
    deselectRootPage(state, payload) {
      state.selectedRootPages = state.selectedRootPages
        .filter(cat => cat !== payload);
    },

    updatePreselectPage(state, payload) {
      state.preselectPage = payload;
    },
  },

  getters: {
    selectedTags: state => state.selectedTags,
    selectedRootPages: state => state.selectedRootPages,
    preselectPage: state => state.preselectPage,
  },
};
